interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma 75644:18038 — "Map" tab icon (location marker). */
const FigmaMapTabIcon = ({ width = 16, height = 18, color = '#121826' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 15.0735 17.9991'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.53676 17.9991L7.01395 17.5509C6.29321 16.9474 0 11.5124 0 7.53676C0 3.37433 3.37433 0 7.53676 0C11.6992 0 15.0735 3.37433 15.0735 7.53676C15.0735 11.5124 8.78031 16.9475 8.06256 17.5539L7.53676 17.9991ZM7.53676 1.62967C4.27591 1.63336 1.63339 4.27588 1.6297 7.53673C1.6297 10.0343 5.50153 14.0241 7.53676 15.8502C9.57203 14.0234 13.4438 10.0313 13.4438 7.53673C13.4401 4.27588 10.7976 1.63339 7.53676 1.62967Z'
      fill={color}
    />
    <path
      d='M7.53676 10.5243C5.88681 10.5243 4.54925 9.18671 4.54925 7.53676C4.54925 5.88681 5.88681 4.54925 7.53676 4.54925C9.18671 4.54925 10.5243 5.88681 10.5243 7.53676C10.5243 9.18671 9.18675 10.5243 7.53676 10.5243ZM7.53676 6.04297C6.71179 6.04297 6.04301 6.71175 6.04301 7.53673C6.04301 8.3617 6.71179 9.03048 7.53676 9.03048C8.36174 9.03048 9.03051 8.3617 9.03051 7.53673C9.03051 6.71175 8.36177 6.04297 7.53676 6.04297Z'
      fill={color}
    />
  </svg>
);

export default FigmaMapTabIcon;
